module.exports = function(data) {
var __t, __p = '';
__p += '<div class="block">\n    <div class="by-label">Count <i class="fas fa-question-circle pz-popover sales-popover" role="button" data-toggle="popover" data-trigger="hover" data-placement="top" data-html="true" data-content="' +
((__t = ( strings.dashboard.widgets.rate_network.received_tooltip )) == null ? '' : __t) +
'"></i></div>\n    <div class="value">' +
((__t = ( data.count )) == null ? '' : __t) +
'</div>\n</div>\n<div class="block">\n    <div class="by-label">Amount <i class="fas fa-question-circle pz-popover sales-popover" role="button" data-toggle="popover" data-trigger="hover" data-placement="top" data-html="true" data-content="' +
((__t = ( strings.dashboard.widgets.rate_network.disputedValue_tooltip )) == null ? '' : __t) +
'"></i></div>\n    <div class="value">' +
((__t = ( data.amount )) == null ? '' : __t) +
'</div>\n</div>\n';
return __p
}